import { Component } from '@angular/core';

@Component({
  selector: 'app-directors-advisors',
  imports: [],
  templateUrl: './directors-advisors.html',
  styleUrl: './directors-advisors.scss'
})
export class DirectorsAdvisors {

}
